import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { push } from "connected-react-router";
import { isEmpty } from "lodash";
import { actions as formActions } from "reducers/form";
import { transactionStatus } from "pages/transactions/constants";

export const useTransaction = (confirmRoute, signAction, cleanAction, formatTransaction) => {
    const dispatch = useDispatch();
    const { pathname, state = {} } = useLocation();
    const { id } = useParams();

    const { transaction, fetching: isLoading } = useSelector((_state) => _state.form);

    const isBackoffice = pathname.includes("backoffice");
    const isFinished = transactionStatus.FINISHED === transaction.idTransactionStatus;
    const isProcessing = transactionStatus.PROCESSING === transaction.idTransactionStatus;
    const isPending = transactionStatus.PENDING === transaction.idTransactionStatus;
    const isCancelled = transactionStatus.CANCELLED === transaction.idTransactionStatus;
    const isScheduled = transactionStatus.SCHEDULED === transaction.idTransactionStatus;
    const isFailed = transactionStatus.FAILED === transaction.idTransactionStatus;

    const { user } = useSelector((_state) => _state.session);

    const showSignButton =
        isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId)) &&
        transaction.idTransactionStatus === transactionStatus.PENDING;

    const isFlowComplete =
        state.isFlowComplete || isFinished || isProcessing || isPending || isCancelled || isScheduled || isFailed;

    const handleSignTransaction = () => {
        const { data, idTransaction } = transaction;
        const formatDataToSign = formatTransaction(data, idTransaction);
        dispatch(signAction(formatDataToSign));
        dispatch(push(confirmRoute));
    };

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readAgreementTransaction(id));
        }
    }, [id, dispatch]);

    useEffect(
        () => () => {
            if (cleanAction) {
                dispatch(cleanAction());
            }
        },
        [],
    );

    return {
        isLoading,
        transaction,
        handleSignTransaction,
        showSignButton,
        push,
        dispatch,
        id,
        status: {
            isFinished,
            isProcessing,
            isFlowComplete,
            isPending,
            isCancelled,
            isScheduled,
            isBackoffice,
            isFailed,
        },
        userId: user?.userId,
        routerState: state,
    };
};

export default useTransaction;
